export default __webpack_public_path__ + "static/media/error.0b9618a9.jpg";